/**
 * User Type Surface Access Control
 *
 * This module defines the orthogonal concept of "user type" which controls
 * which UI surfaces are visible to a user based on their job function.
 *
 * Three orthogonal concepts in the access control system:
 * - Roles: What you can DO (capabilities like admin, impersonator)
 * - UserType: What you SEE (UI surfaces like pipeline, agenda)
 * - Manager: Who controls your artifact visibility (blocklist)
 */

import { UserType } from '@prisma/client';

// Re-export Prisma enum for convenience
export { UserType };

/**
 * User type display information for admin UIs
 */
export const USER_TYPE_INFO: Record<
  UserType,
  { label: string; shortLabel: string; description: string }
> = {
  MEMBER: {
    label: 'Member',
    shortLabel: 'Member',
    description: 'Default access to categories, accounts, pipeline, and agenda',
  },
  PRE_SALES: {
    label: 'Pre-Sales (GTM Engineer)',
    shortLabel: 'GTME',
    description: 'Access to categories, accounts, pipeline, and agenda',
  },
  POST_SALES: {
    label: 'Post-Sales (Growth Strategist)',
    shortLabel: 'EGS',
    description: 'Access to categories, accounts, and agenda (no pipeline)',
  },
  REVOPS: {
    label: 'RevOps',
    shortLabel: 'RevOps',
    description: 'Access to categories, accounts, pipeline, and agenda',
  },
  SDR: {
    label: 'SDR (Sales Development Rep)',
    shortLabel: 'ClayDR',
    description: 'Access to categories, accounts, pipeline, and agenda',
  },
};

export const USER_TYPES = Object.values(UserType);
